import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import RankingSection from "./components/RankingSection";
import LatestSection from "./components/LatestSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <main>
      <HeroSection />
      <CategorySection />
      <RankingSection />
      <LatestSection />
      <CTASection />
      <FAQSection />
    </main>
  );
}